import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function CustomThemeProvider(props) {
    const userPreferenceDarkmode = useMediaQuery('(prefers-color-scheme: dark)');
    let darkmode = props.darkmode;
    if(props.overrideDarkmode === false || darkmode === undefined || darkmode === null) {
        darkmode = userPreferenceDarkmode;
    }
    if(props.reportUserPreferenceDarkmode) {
        props.reportUserPreferenceDarkmode(userPreferenceDarkmode);
    }
    //console.log("Darkmode-Settings:\nOverrideDarkmode: " + props.overrideDarkmode + "\ndarkmode: " + props.darkmode + "\nuserPreferenceDarkmode: " + userPreferenceDarkmode + "\nset darkmode to: " + darkmode);
    let theme = {
        palette: {
            type: darkmode ? 'dark' : 'light',
            primary: {
                main: '#a9d18e',
            },
            secondary: {
                main: '#599bd5',
            },
            merke: {
                main: '#ff0000',
                dark: '#c30000',
                light: '#ff6333',
            },
            definition: {
                main: '#ffff00',
                dark: '#c79a00',
                light: '#ffca28',
            }
        },
    };

    return (
        <ThemeProvider theme={createMuiTheme(theme)}>
            {props.children}
        </ThemeProvider>
    );
}

class Theme extends React.Component {

    static #instances = [];
    static #darkmode = window.localStorage.getItem('darkmode') === 'true';
    static #overrideDarkmode = window.localStorage.getItem('overrideDarkmode') === 'true';

    constructor(...args) {
        super(...args);
        this.state = {
            darkmode: Theme.#darkmode,
            overrideDarkmode: Theme.#overrideDarkmode,
        };
    }

    componentDidMount() {
        Theme.#instances.push(this);
    }

    componentWillUnmount() {
        var index = Theme.#instances.indexOf(this);
        if (index !== -1) Theme.#instances.splice(index, 1);
    }

    static setDarkmode(darkmode) {
        Theme.#overrideDarkmode = true;
        Theme.#darkmode = darkmode;
        window.localStorage.setItem('darkmode', Theme.#darkmode);
        window.localStorage.setItem('overrideDarkmode', Theme.#overrideDarkmode);
        Theme.#instances.forEach((element) => {
            element.setDarkmode(darkmode);
            element.setOverrideDarkmode(true);
        });
    }

    static getDarkmode() {
        return Theme.#darkmode;
    }

    static getOverrideDarkmode() {
        return Theme.#overrideDarkmode;
    }

    static defaultDarkmode() {
        Theme.#overrideDarkmode = false;
        Theme.#instances.forEach((element) => {
            element.setOverrideDarkmode(false);
        });
        window.localStorage.setItem('overrideDarkmode', Theme.#overrideDarkmode);
    }

    static toggleDarkmode() {
        this.setDarkmode(!this.getDarkmode());
        return this.getDarkmode();
    }

    setDarkmode(darkmode) {
        this.setState({
            'darkmode': darkmode,
        });
    }

    setOverrideDarkmode(override) {
        this.setState({
            overrideDarkmode: override,
        });
    }

    render() {
        return (
            <CustomThemeProvider reportUserPreferenceDarkmode={(d) => (!this.state.overrideDarkmode && (Theme.#darkmode = d))} overrideDarkmode={this.state.overrideDarkmode} darkmode={this.state.darkmode}>
                {this.props.children}
            </CustomThemeProvider>
        )
    }
}

export default Theme;